import React from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
// Fix for default marker icons
delete (L.Icon.Default.prototype as any)._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.7.1/images/marker-shadow.png'
});
interface Location {
  lat: number;
  lng: number;
  name: string;
  status: string;
}
interface ShipmentMapProps {
  origin: Location;
  destination: Location;
  currentLocation?: Location;
}
const ShipmentMap: React.FC<ShipmentMapProps> = ({
  origin,
  destination,
  currentLocation
}) => {
  // Calculate bounds to fit all markers
  const bounds = L.latLngBounds([[origin.lat, origin.lng], [destination.lat, destination.lng]]);
  if (currentLocation) {
    bounds.extend([currentLocation.lat, currentLocation.lng]);
  }
  return <MapContainer bounds={bounds} className="h-[400px] w-full rounded-lg z-0" zoom={13} data-id="element-420">
      <TileLayer attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors' url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" data-id="element-421" />
      <Marker position={[origin.lat, origin.lng]} data-id="element-422">
        <Popup data-id="element-423">{origin.name}</Popup>
      </Marker>
      {currentLocation && <Marker position={[currentLocation.lat, currentLocation.lng]} data-id="element-424">
          <Popup data-id="element-425">
            Current Location
            <br data-id="element-426" />
            {currentLocation.status}
          </Popup>
        </Marker>}
      <Marker position={[destination.lat, destination.lng]} data-id="element-427">
        <Popup data-id="element-428">{destination.name}</Popup>
      </Marker>
    </MapContainer>;
};
export default ShipmentMap;